export class OverrideNetworkClassificationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkClassification",
            "baseName": "networkClassification",
            "type": "NetworkClassification",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideNetworkClassificationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
